// extracted by mini-css-extract-plugin
export default {"root":"IconLikeStars_root__4CJKt"};